import * as yup from 'yup';

export default yup.object({
  template: yup
    .object()
    .shape({
      text: yup.string().required(),
      value: yup.string().required(),
    })
    .required(),
  language: yup.string().required(),
});
